import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface CommandCenterCardProps {
  title: string;
  description?: string;
  icon?: LucideIcon;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  variant?: "default" | "alert" | "success";
}

const variantStyles = {
  default: "border-border",
  alert: "border-amber-warning/40 bg-amber-50/30",
  success: "border-green-approved/40 bg-green-50/30",
} as const;

export function CommandCenterCard({
  title,
  description,
  icon: Icon,
  action,
  children,
  className,
  variant = "default",
}: CommandCenterCardProps) {
  return (
    <section
      className={cn(
        "rounded-xl border bg-card-white shadow-[var(--shadow-card)]",
        variantStyles[variant],
        className,
      )}
    >
      <header className="flex items-start justify-between gap-4 border-b border-border/60 px-5 py-4">
        <div className="flex items-start gap-3">
          {Icon ? (
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-navy-deep text-orange-construction">
              <Icon className="h-4 w-4" />
            </div>
          ) : null}
          <div>
            <h3 className="font-semibold text-navy-deep">{title}</h3>
            {description ? (
              <p className="mt-0.5 text-sm text-muted-foreground">{description}</p>
            ) : null}
          </div>
        </div>
        {action}
      </header>
      <div className="p-5">{children}</div>
    </section>
  );
}
